import React from 'react';
import moment from 'moment';
import { IUnit } from '@/types';
import UICollapsibleSection from '@/components/shared/UICollapsibleSection';
import './LeaseTerms.scss';

interface LeaseTermsProps {
  unit: IUnit | null;
  collapsed: boolean;
  onToggleCollapse: () => void;
}

const baseClass = 'LeaseTerms';

const LeaseTerms: React.FC<LeaseTermsProps> = ({
  unit,
  collapsed,
  onToggleCollapse,
}) => {
  return (
    <UICollapsibleSection
      title="Terms of lease"
      collapsed={collapsed}
      onToggleCollapse={onToggleCollapse}
      className={`${baseClass} mb-24`}
    >
      <div className={`${baseClass}--container`}>
        {unit?.lease?.isFixed === 'fixed' ? (
          <div className={`${baseClass}--content`}>
            <div className={`${baseClass}--content-title`}>
              <i className="fa-solid fa-calendar-days"></i>
              <span className={`${baseClass}--content-title-text`}>
                Fixed term lease
              </span>
            </div>
            <div className={`${baseClass}--content-row`}>
              <span>The term of lease is </span>
              <span className={`${baseClass}--content-tag`}>
                {unit?.lease?.period}
              </span>
              <span> from </span>
              <span className={`${baseClass}--content-tag`}>
                {unit?.lease?.startDate
                  ? moment(unit.lease.startDate).format('YYYY-MM-DD')
                  : 'N/A'}
              </span>
              <span> to </span>
              <span className={`${baseClass}--content-tag`}>
                {unit?.lease?.endDate
                  ? moment(unit.lease.endDate).format('YYYY-MM-DD')
                  : 'N/A'}
              </span>
            </div>
          </div>
        ) : (
          <div className={`${baseClass}--content`}>
            <div className={`${baseClass}--content-title`}>
              <i className="fa-solid fa-calendar-days"></i>
              <span className={`${baseClass}--content-title-text`}>
                Indeterminate term lease
              </span>
            </div>
            <div className={`${baseClass}--content-row`}>
              <span>Beginning on </span>
              <span className={`${baseClass}--content-tag`}>
                {unit?.lease?.indeterminateStartDate
                  ? moment(unit.lease.indeterminateStartDate).format(
                      'YYYY-MM-DD',
                    )
                  : 'N/A'}
              </span>
            </div>
          </div>
        )}
      </div>
    </UICollapsibleSection>
  );
};

export default LeaseTerms;
